<template>
  <div class="signup-view">
    <div class="container" :class="{ 'is-wide': isRoleSelection }">
      <RouterView />
    </div>
    <div class="container is-wide mt-4">
      <SolderaLogoStripComponent />
    </div>
    <div class="container">
      <p class="fs-9 text-body-tertiary signup-legal-section mt-3 text-center">
        <!-- Corporations accept the Platform Agreement in the dashboard's onboarding modal, not here. -->
        <template v-if="!isCorporateSignup">
          {{ $t("signup.legal.byJoining") }}
          <a
            href="https://soldera.org/terms"
            target="_blank"
            rel="noopener noreferrer"
            class="signup-link"
          >
            {{ $t("signup.legal.membershipAgreement") }}
          </a>
          <br class="d-none d-md-inline" />
        </template>
        {{ $t("signup.legal.personalDataNote") }}
        <a
          :href="privacyPolicyLink"
          target="_blank"
          rel="noopener noreferrer"
          class="signup-link"
        >
          {{ $t("signup.legal.privacyPolicy") }}
        </a>
      </p>
    </div>
  </div>
</template>
<script setup lang="ts">
import SolderaLogoStripComponent from "@/components/proof/SolderaLogoStripComponent.vue";
import { useRouteCountry } from "@/composables/route/useCountry";
import { computed } from "vue";
import { useRoute } from "vue-router";

// Signup names the country in the query (?country=lv), the same one the signup store follows.
const country = useRouteCountry("EN");

const PRIVACY_POLICY_LINKS: Record<string, string> = {
  EE: "https://www.soldera.org/et/vastavus/privaatsuspoliitika",
  LV: "https://www.soldera.org/lv/atbilstiba/privatuma-politika",
  LT: "https://www.soldera.org/lt/atitiktis/privatumo-politika",
  EN: "https://www.soldera.org/compliance/privacy-policy",
};

const route = useRoute();
const isCorporateSignup = computed(() => route.name === "CorporateSignUp");
const isRoleSelection = computed(() => route.name === "RoleSelection");

const privacyPolicyLink = computed(
  () => PRIVACY_POLICY_LINKS[country.value] ?? PRIVACY_POLICY_LINKS["EN"]
);
</script>

<style scoped lang="scss">
.signup-view {
  overflow-y: auto;
  .container {
    max-width: 800px;

    // The path chooser and the proof band need room for two columns.
    &.is-wide {
      max-width: 1040px;
    }
  }
}

.signup-legal-section {
  a.signup-link {
    color: rgb(var(--phoenix-primary-light-rgb));
    font-weight: 500;
    &:hover {
      color: rgb(var(--phoenix-link-color-rgb));
    }
  }
}
</style>
